import React from 'react';

import { PickerSelection } from '@rbi-ctg/menu';
import { ComboSlotType } from 'components/product-detail-v2/product-customization/ComboSlotType';
import { getComboSlotType } from 'components/product-detail-v2/product-customization/utils';
import { t } from 'state/intl/translations';
import { IUserSelection } from 'state/product-wizard-v2/types';
import { isCombo } from 'utils/menu';

import { findNextValidComboSlotKey, getNextComboSlotKey } from './utils';

export const useGetNextComboSlotLabel = ({
  slotKeyToCustomize,
  userSelections,
  selectedProduct,
}: {
  slotKeyToCustomize: string;
  userSelections: IUserSelection;
  selectedProduct: PickerSelection;
}) => {
  const nextComboSlotKey = React.useMemo(
    () =>
      getNextComboSlotKey({
        slotKeyToCustomize,
        userSelections,
      }),
    [slotKeyToCustomize, userSelections]
  );

  if (!userSelections.comboSlot || !slotKeyToCustomize) {
    return t('nextCustomize');
  }

  if (!nextComboSlotKey) {
    return isCombo(selectedProduct) ? t('nextReviewYourMeal') : t('nextReviewYourSelection');
  }

  const nextValidComboSlotKey = findNextValidComboSlotKey(nextComboSlotKey, userSelections);

  const nextItemToCustomize = nextValidComboSlotKey
    ? userSelections.comboSlot.get(nextValidComboSlotKey)?.selectedItem
    : null;

  if (!nextItemToCustomize) {
    return t('nextCustomize');
  }

  // Get the combo slot type for the next item
  const comboSlotType = getComboSlotType(nextItemToCustomize);

  switch (comboSlotType) {
    case ComboSlotType.SIDES:
      return t('nextSelectYourSide');
    case ComboSlotType.DRINKS:
      return t('nextSelectYourDrink');
    default:
      return t('nextCustomize');
  }
};
